import React, { useEffect } from "react";
import { useKeycloak } from "@react-keycloak/web";
import { Navigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setUser } from "../redux/slieces/authSlice";
import logger from "../core/utils/logger";

const ProtectedRoute = ({ children }) => {
  const { keycloak, initialized } = useKeycloak();
  const dispatch = useDispatch();

  useEffect(() => {
    if (keycloak.authenticated) {
      dispatch(setUser({ user: keycloak.tokenParsed, token: keycloak.token }));
    }
  }, [keycloak.authenticated, dispatch]);

  if (!initialized) {
    return <div>Loading...</div>;
  }
  logger.log(keycloak.authenticated);
  logger.log(children);

  return keycloak.authenticated ? children : <Navigate to="/" />;
};

export default ProtectedRoute;